import { render, staticRenderFns } from "./ModuloRapido.vue?vue&type=template&id=4b3182f8"
import script from "./ModuloRapido.vue?vue&type=script&lang=js"
export * from "./ModuloRapido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports